// Polyfills
import '@babel/polyfill';
import 'url-polyfill';
import 'isomorphic-fetch';
import 'delayed-scroll-restoration-polyfill';

// Library CSS
import 'cropperjs/dist/cropper.min.css';
import 'flatpickr/dist/flatpickr.css';

require('!style-loader!css-loader!video.js/dist/video-js.css');

import React from 'react';
import ReactDOM from 'react-dom';

import 'config/braze';
import 'config/yup';
import 'config/browser';

import App from 'startup/App';

ReactDOM.render(<App />, document.getElementById('root'));
